import { useContext, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { CSSObjectWithLabel } from 'react-select';
import Select from 'react-select/creatable';
import { SearchGroupTagsContext } from '../../contexts';
import { GroupTagUpdateItem } from '@trinity/chat';
import { useDebounceValue } from '@trinity/chat-components/hooks';

type Props = {
  onChange: (items: GroupTagUpdateItem) => void;
  defaultValue?: GroupTagUpdateItem[];
};

type Option = GroupTagUpdateItem;

// Similar to the GroupTagSelect component, but allows for single selection and clears the input after selection.
export const GroupTagPicker = (props: Props) => {
  const [value, setValue] = useState<Option | null>(null);
  const [input, setInput] = useState('');

  const searchTags = useContext(SearchGroupTagsContext);

  const debouncedValue = useDebounceValue(input, 200);

  const searchQuery = useQuery({
    queryKey: ['get-group-tags', debouncedValue],
    queryFn: () => searchTags({
      query: debouncedValue,
    }),
  });

  const handleChange = (newVal: Option) => {
    setValue(newVal);
    props.onChange(newVal);
    setInput('');
    setValue(null);
  };

  return (
    <Select<Option, false>
      value={value}
      options={searchQuery.data?.results ?? []}
      styles={{
        menuPortal: base => ({ ...base, zIndex: 10 }) as CSSObjectWithLabel,
        menu: base => ({ ...base, zIndex: 10 }) as CSSObjectWithLabel,
      }}
      getOptionLabel={x => x.name}
      getOptionValue={x => x.id?.toString()}
      menuPortalTarget={document.body}
      formatCreateLabel={input => `Create "${input}"`} //This doesn't seem to actually work
      isValidNewOption={input => input.length > 2}
      inputValue={input}
      onInputChange={setInput}
      getNewOptionData={input => ({ id: input, name: input })}
      isLoading={searchQuery.isLoading}
      onChange={newVal => handleChange(newVal)}
      defaultValue={props.defaultValue} />
  );
};